import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import CandidateSummaryClientInterview from "./CandidateSummaryClientInterview";

type Props = {
  candidate?: CandidateDetails;
  job?: JobRequestDetails;
  selectedStage?: string;
};

const ClientInterviewTab = ({ candidate, job, selectedStage }: Props) => {
  const { data: allMeetings } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: selectedStage || "",
  });
  const meetingData = allMeetings?.data[0];

  if (!meetingData) {
    return (
      <Grid container alignItems="center">
        <Typography color="#3F4871" fontSize={24} fontWeight={700}>
          Candidate has not selected a timeslot yet.
        </Typography>
      </Grid>
    );
  }

  const meetingEnd = meetingData.meetingEndedOn
    ? new Date(meetingData.meetingEndedOn).getTime()
    : null;
  const meetingStart = meetingData.meetingStartedOn
    ? new Date(meetingData.meetingStartedOn).toLocaleString()
    : "";

  const now = Date.now();

  if (!meetingEnd || meetingEnd > now) {
    return (
      <Grid container justifyContent={"center"} direction={"column"}>
        <Typography color="#3F4871" fontSize={24} fontWeight={500}>
          Candidate has confirmed the timeslot and the interview is scheduled at{" "}
        </Typography>
        <Typography color="#3F4871" fontSize={24} fontWeight={700}>
          {moment
            .utc(meetingData.meetingStartedOn)
            .local()
            .format("Do MMM yy, hh:mm a")}
        </Typography>
      </Grid>
    );
  }

  // If meeting has ended, show CandidateSummary
  return (
    <CandidateSummaryClientInterview
      candidate={candidate}
      meeting={meetingData}
      jobId={job?.jobId}
    />
  );
};

export default ClientInterviewTab;
